import {
  put, call, all, select,
} from 'redux-saga/effects';

import { getErrorMessage } from 'utils/filters';
import {
  apiEditAddress, apiEditAddressCompany, apiIncludeAddressCompany, checkIfIsAddressCompany,
} from 'services/api/address';
import { Creators as UiCreators, growlTypes } from '../ducks/ui';
import { getTokenUser, getTriiderUser, Creators as AuthCreators } from '../ducks/auth';
import { newTask, updateUser } from '../../services/api/task';
import { getCompanyId, getCompany as getCompanySource } from '../ducks/company';
import { Creators as TaskCreators } from '../ducks/task';
import { history } from '..';
import { Creators as CreatorsForm } from '../ducks/serviceForm';

// import { initializeGA, gaSendEvent } from '../../helpers/analytics';

const fileName = 'sagas/serviceForm';

export function* finishForm({ payload: task }) {
  try {
    yield put(UiCreators.showLoader('SERVICE_FORM'));
    const token = yield select(getTokenUser);
    const companyId = yield select(getCompanyId);
    const sourceCompany = yield select(getCompanySource);
    const triiderUser = yield select(getTriiderUser);

    task = {
      ...task,
      company_id: companyId,
      source: 'partners',
      partner: {
        name: sourceCompany,
        user_partner_role: triiderUser.role,
      },
    };

    if (token) {
      if (!task.address_id) {
        let resultAddressCompany = [];
        try {
          const isAddressCompanyList = yield call(checkIfIsAddressCompany, task.address_detail, task.service_id);
          resultAddressCompany = isAddressCompanyList.result;
        } catch (error) {
          console.error(error);
        }

        try {
          const addressOfUser = resultAddressCompany.filter(ad => ad.company_id === companyId);
          // sempre enviar user_id
          if (addressOfUser.length === 0) {
            const data = yield call(apiIncludeAddressCompany, {
              ...task.address_detail,
              user_id: triiderUser.user.id,
            }, companyId);
            task.address_id = data.address.id;
          } else {
            const addressEdit = { ...task.address_detail, id: addressOfUser[0].id };
            const data = yield call(apiEditAddressCompany,
              {
                ...addressEdit,
                user_id: triiderUser.user.id,
              }, companyId);
            task.address_id = data.address.id;
          }
        } catch (error) {
          console.error(error);
        }
      } else if (triiderUser.user.id !== task.address_detail.user_id) {
        yield call(apiEditAddress, {
          user_id: triiderUser.user.id,
          id: task.address_id,
        });
      }

      const data = yield call(newTask, companyId, task);
      yield put(CreatorsForm.closeForm());
      yield put(TaskCreators.getTaskRequest(triiderUser.user));
      yield put(TaskCreators.setTaskResponsibility(data.responsibility_bucket_id));
      yield put(UiCreators.hideLoader('SERVICE_FORM'));

      history.push('/pedido-finalizado');
    } else {
      yield localStorage.setItem('task', JSON.stringify(task));
      yield localStorage.setItem('hasTaskExternal', true);
      yield localStorage.setItem('isPartner', true);

      yield put(CreatorsForm.closeForm());
      yield put(UiCreators.hideLoader('SERVICE_FORM'));
      yield window.open(`${process.env.SITE_PATH}u/finalizar`);
      history.push(`/partner/${sourceCompany || 'triider'}`);
    }

    // com token
  } catch (error) {
    const message = getErrorMessage(error);
    yield all([
      put(
        UiCreators.growl(message, growlTypes.GROWL_ERROR, {
          error,
          method: `${fileName}/finishForm`,
        }),
      ),
      put(UiCreators.hideLoader('SERVICE_FORM')),
    ]);
  }
}
